var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillOpacity: 0,
    d: "M0 0L52 0 52 52 0 52z",
    transform: "translate(-4 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0,
    d: "M0 0H52V52H0z",
    transform: "translate(-4 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020D11",
    d: "M26 43.333c-9.555 0-17.333-7.778-17.333-17.333S16.445 8.667 26 8.667 43.333 16.445 43.333 26 35.555 43.333 26 43.333z",
    transform: "translate(-4 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M26 4.333C14.04 4.333 4.333 14.04 4.333 26S14.04 47.667 26 47.667 47.667 37.96 47.667 26 37.96 4.333 26 4.333zm0 39c-9.555 0-17.333-7.778-17.333-17.333S16.445 8.667 26 8.667 43.333 16.445 43.333 26 35.555 43.333 26 43.333z",
    transform: "translate(-4 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38BCEE",
    d: "M21.667 35.75L34.667 26 21.667 16.25z",
    transform: "translate(-4 -4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPlay);
export default __webpack_public_path__ + "static/media/icons-play.257d890977f41604f1b3a5b27c6f9dbe.svg";
export { ForwardRef as ReactComponent };